import React, { useState } from 'react';
import { Box, Button, CircularProgress, DialogContent, Typography } from '@mui/material';
import { CheckCircleOutline as CheckCircleOutlineIcon, HighlightOffOutlined as HighlightOffOutlinedIcon } from '@mui/icons-material';
import { inject, observer } from 'mobx-react';
import { compose } from 'utils/compose';

import { DialogActionButton } from 'components/Dialog';

import withMediaQuery from 'constants/mediaQuery';
import { useStyles } from 'containers/main/styles';

function DialogStepThree({ handleClose, isSuccess, store, setImages }) {
  const classes = useStyles();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleGetPOD = () => {
    setIsSubmitting(true);
    try {
      store.deliveryStore.getPOD((res) => {
        // Validate that res.data is an array before setting it
        const images = Array.isArray(res.data) ? res.data : [];
        setImages(images);
        store.podStore.setImagesPOD(images);
        store.deliveryStore.getPackageLocation();
        store.deliveryStore.getFeedback();
        handleClose();
      });
    } catch (error) {
      /* empty */
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <DialogContent style={{ paddingBottom: '10px' }}>
      <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
        <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {isSuccess ? (
            <>
              <CheckCircleOutlineIcon sx={{ ...classes.textSuccess, fontSize: 40 }} />
              <Typography style={{ fontSize: 20, fontWeight: 600, marginLeft: '8px' }}>Successfully Verified</Typography>
            </>
          ) : (
            <>
              <HighlightOffOutlinedIcon sx={{ ...classes.textError, fontSize: 40 }} />
              <Typography style={{ fontSize: 20, fontWeight: 600, marginLeft: '8px' }}>Error Verified</Typography>
            </>
          )}
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: '50px' }}>
          <DialogActionButton color={isSubmitting ? 'default' : 'primary'} onClick={handleGetPOD} variant="contained" disableElevation>
            {isSubmitting && <CircularProgress />}
            {!isSubmitting && 'OK'}
          </DialogActionButton>
        </Box>
      </Box>
    </DialogContent>
  );
}
const DialogStepThreeCompose = compose(inject('store'), observer)(DialogStepThree);

export default withMediaQuery()(DialogStepThreeCompose);
